import { POST_SOCIAL_STATUS, POST_STATUS, POST_TYPE } from '../../models/post'

export interface IAppState {
  initial: null
  headerView: HEADER_VIEW
  calendarView: CALENDAT_VIEW
  isShowPopup: boolean
  isShowLabels: boolean
  timezones: any
  inProgress: boolean
  filters: any
  isOpenAddProject: boolean
  isOpenEditProfile: boolean
  isOpenNotificationSetting: boolean
  isOpenHashtagSetting: boolean,
  isOpenPostType: boolean
  isOpenAddPost: boolean
  isInviteModalOpen: boolean
  successModal: {
    isOpen: boolean
    message: string
  }
  scheduleModal: {
    isOpen: boolean
    actionType: SCHEDULE_ACTION_TYPES | null
  },
  approvalListType: APPROVAL_LIST_TYPE,
  filtersIntervalApproval:any,
  filtersExternalApproval:any
}

export enum HEADER_VIEW {
  CALENDAR = 'calendar',
  APPROVALS = 'approvals',
  APPROVAL_ITEM = 'approval-item',
  CONTENT = 'content',
  REPORTS = 'reports',
  ANALYTICS = 'analytics',
  PROJECT_SETTINGS = 'project-settings',
  SOCIAL_ACCOUNTS = 'social-accounts',
  TEAM = 'team',
  CLIENT = 'external-approver',
  BILLING = 'billing',
  NOTIFICATIONS = 'notifications',
  HASHTAG = 'Hashtag Pools',
  CALENDAR_APPROVAL = 'calendar',
}

export enum SCHEDULE_ACTION_TYPES {
  SINGLE_SCHEDULE = 'single-shedule',
  SHEDULE_TO_ROUTE = 'schedule-to-route',
  BATCH_SCHEDULES = 'batch-shedules',
  SCHEDULE_DUPLICATE = 'schedule-duplicate',
  SCHEDULE_BEFORE_APPROVAL = 'schedule-before-approval'
}

export const filters = {
  status: [
    {
      name: 'Draft',
      labelColor: '#9ba1b0',
      id: POST_SOCIAL_STATUS.STATUS_DRAFT,
      values: [POST_SOCIAL_STATUS.STATUS_DRAFT],
      checked: false
    },
    {
      name: 'Requires revision',
      labelColor: '#e85160',
      id: POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION,
      values: [POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION],
      checked: false
    },
    {
      name: 'Pending internal approval',
      labelColor: '#f1c40f',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL],
      checked: false
    },
    {
      name: 'Pending external approval',
      labelColor: '#f3a66a',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL],
      checked: false
    },
    {
      name: 'Pending manual publish',
      labelColor: '#21cca4',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH],
      checked: false
    },
    {
      name: 'Scheduled',
      labelColor: '#0391d3',
      id: POST_SOCIAL_STATUS.STATUS_SCHEDULED,
      values: [POST_SOCIAL_STATUS.STATUS_SCHEDULED],
      checked: false
    },
    {
      name: 'Publishing failed',
      labelColor: '#9b0000',
      id: POST_SOCIAL_STATUS.STATUS_PUBLISHING_FAILED,
      values: [POST_SOCIAL_STATUS.STATUS_PUBLISHING_FAILED],
      checked: false
    },
    {
      name: 'Live',
      labelColor: '#374db1',
      id: POST_SOCIAL_STATUS.STATUS_LIVE,
      values: [POST_SOCIAL_STATUS.STATUS_LIVE],
      checked: false
    }
  ],
  label: [],
  social_post_type: [
    {
      name: 'Story',
      id: 'story',
      values: [POST_TYPE.POST_TYPE_PHOTO_STORY, POST_TYPE.POST_TYPE_VIDEO_STORY],
      labelColor: '#233412',
      checked: false
    },
    {
      name: 'Original',
      id: 'original',
      values: [
        POST_TYPE.POST_TYPE_LINK,
        POST_TYPE.POST_TYPE_SINGLE_PHOTO,
        POST_TYPE.POST_TYPE_MULTI_PHOTO,
        POST_TYPE.POST_TYPE_SINGLE_VIDEO,
        POST_TYPE.POST_TYPE_MULTI_VIDEO,
        POST_TYPE.POST_TYPE_MULTI_CONTENT,
        POST_TYPE.POST_TYPE_ANIMATED_GIF,
        POST_TYPE.POST_TYPE_TEXT,
        POST_TYPE.POST_TYPE_LINK_CAROUSEL,
        POST_TYPE.POST_TYPE_REELS
      ],
      labelColor: '#E85160',
      checked: false
    }
  ],
  social_network: [
    {
      name: 'Instagram',
      id: 'instagram',
      labelColor: '#FF543E',
      checked: false
    },
    {
      name: 'Facebook',
      id: 'facebook',
      labelColor: '#3B5998',
      checked: false
    },
    {
      name: 'Twitter',
      id: 'twitter',
      labelColor: '#1DA1F2',
      checked: false
    },
    {
      name: 'LinkedIn',
      id: 'linkedin',
      labelColor: '#0E76A8',
      checked: false
    }
  ]
}

export const filtersIntervalApproval = {
  status: [
    // {
    //   name: 'Requires revision',
    //   labelColor: '#e85160',
    //   id: POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION,
    //   values: [POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION],
    //   checked: false
    // },
    {
      name: 'Pending internal approval',
      labelColor: '#f1c40f',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL],
      checked: false
    },
    {
      name: 'Pending external approval',
      labelColor: '#f3a66a',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL],
      checked: false
    },
    {
      name: 'Pending manual publish',
      labelColor: '#21cca4',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH],
      checked: false
    },
    {
      name: 'Scheduled',
      labelColor: '#0391d3',
      id: POST_SOCIAL_STATUS.STATUS_SCHEDULED,
      values: [POST_SOCIAL_STATUS.STATUS_SCHEDULED],
      checked: false
    },
    {
      name: 'Publishing failed',
      labelColor: '#9b0000',
      id: POST_SOCIAL_STATUS.STATUS_PUBLISHING_FAILED,
      values: [POST_SOCIAL_STATUS.STATUS_PUBLISHING_FAILED],
      checked: false
    },
    {
      name: 'Live',
      labelColor: '#374db1',
      id: POST_SOCIAL_STATUS.STATUS_LIVE,
      values: [POST_SOCIAL_STATUS.STATUS_LIVE],
      checked: false
    }
  ],
  label: [],
  social_post_type: [
    {
      name: 'Story',
      id: 'story',
      values: [POST_TYPE.POST_TYPE_PHOTO_STORY, POST_TYPE.POST_TYPE_VIDEO_STORY],
      labelColor: '#233412',
      checked: false
    },
    {
      name: 'Original',
      id: 'original',
      values: [
        POST_TYPE.POST_TYPE_LINK,
        POST_TYPE.POST_TYPE_SINGLE_PHOTO,
        POST_TYPE.POST_TYPE_MULTI_PHOTO,
        POST_TYPE.POST_TYPE_SINGLE_VIDEO,
        POST_TYPE.POST_TYPE_MULTI_VIDEO,
        POST_TYPE.POST_TYPE_MULTI_CONTENT,
        POST_TYPE.POST_TYPE_ANIMATED_GIF,
        POST_TYPE.POST_TYPE_TEXT,
        POST_TYPE.POST_TYPE_LINK_CAROUSEL,
        POST_TYPE.POST_TYPE_REELS
      ],
      labelColor: '#E85160',
      checked: false
    }
  ],
  social_network: [
    {
      name: 'Instagram',
      id: 'instagram',
      labelColor: '#FF543E',
      checked: false
    },
    {
      name: 'Facebook',
      id: 'facebook',
      labelColor: '#3B5998',
      checked: false
    },
    {
      name: 'Twitter',
      id: 'twitter',
      labelColor: '#1DA1F2',
      checked: false
    },
    {
      name: 'LinkedIn',
      id: 'linkedin',
      labelColor: '#0E76A8',
      checked: false
    }
  ]
}

export const filtersExternalApproval = {
  status: [
    // {
    //   name: 'Requires revision',
    //   labelColor: '#e85160',
    //   id: POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION,
    //   values: [POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION],
    //   checked: false
    // },
    {
      name: 'Pending external approval',
      labelColor: '#f3a66a',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL],
      checked: false
    },
    {
      name: 'Pending manual publish',
      labelColor: '#21cca4',
      id: POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH,
      values: [POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH],
      checked: false
    },
    {
      name: 'Scheduled',
      labelColor: '#0391d3',
      id: POST_SOCIAL_STATUS.STATUS_SCHEDULED,
      values: [POST_SOCIAL_STATUS.STATUS_SCHEDULED],
      checked: false
    },
    {
      name: 'Publishing failed',
      labelColor: '#9b0000',
      id: POST_SOCIAL_STATUS.STATUS_PUBLISHING_FAILED,
      values: [POST_SOCIAL_STATUS.STATUS_PUBLISHING_FAILED],
      checked: false
    },
    {
      name: 'Live',
      labelColor: '#374db1',
      id: POST_SOCIAL_STATUS.STATUS_LIVE,
      values: [POST_SOCIAL_STATUS.STATUS_LIVE],
      checked: false
    }
  ],
  label: [],
  social_post_type: [
    {
      name: 'Story',
      id: 'story',
      values: [POST_TYPE.POST_TYPE_PHOTO_STORY, POST_TYPE.POST_TYPE_VIDEO_STORY],
      labelColor: '#233412',
      checked: false
    },
    {
      name: 'Original',
      id: 'original',
      values: [
        POST_TYPE.POST_TYPE_LINK,
        POST_TYPE.POST_TYPE_SINGLE_PHOTO,
        POST_TYPE.POST_TYPE_MULTI_PHOTO,
        POST_TYPE.POST_TYPE_SINGLE_VIDEO,
        POST_TYPE.POST_TYPE_MULTI_VIDEO,
        POST_TYPE.POST_TYPE_MULTI_CONTENT,
        POST_TYPE.POST_TYPE_ANIMATED_GIF,
        POST_TYPE.POST_TYPE_TEXT,
        POST_TYPE.POST_TYPE_LINK_CAROUSEL,
        POST_TYPE.POST_TYPE_REELS
      ],
      labelColor: '#E85160',
      checked: false
    }
  ],
  social_network: [
    {
      name: 'Instagram',
      id: 'instagram',
      labelColor: '#FF543E',
      checked: false
    },
    {
      name: 'Facebook',
      id: 'facebook',
      labelColor: '#3B5998',
      checked: false
    },
    {
      name: 'Twitter',
      id: 'twitter',
      labelColor: '#1DA1F2',
      checked: false
    },
    {
      name: 'LinkedIn',
      id: 'linkedin',
      labelColor: '#0E76A8',
      checked: false
    }
  ]
}

export enum CALENDAT_VIEW {
  MONTH_VIEW = 'dayGridMonth',
  WEEK_VIEW = 'dayGridWeek'
}

export enum TypeActionToModal {
  DELETE_MULTI_POSTS = 'delete_multi_posts',
  DELETE_ONE_POST = 'delete_one_post'
}

export type TModalOptions = {
  type: TypeActionToModal
  postId: number
  postsIds: number[]
}
export enum APPROVAL_LIST_TYPE {
  PENDING = 'pending',
  APPROVED = 'approved'
}
